import { Alert, Button, Card, Col, Form, Input, message, Modal, Row, Spin } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { PHONE_PATTERN } from '../../constants/general'
import InstitutionUserService from '../../services/InstitutionUserService'
import { parseMoneyAmount } from '../../utils/parseMoneyAmount'
import { RefundStatsRangeAlert } from './RefundStatsRangeAlert'
import { v4 as uuidv4 } from 'uuid'
import { useNavigate } from 'react-router-dom'

const RequestPaymentClaim: React.FC = () => {
  const navigate = useNavigate()
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const userRole = userInfo?.role
  const [form] = Form.useForm()
  const [loadingRefund, setLoadingRefund] = useState(false)
  const [declarationChecked, setDeclarationChecked] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [biddersStatus, setBiddersStatus] = useState(false)
  const [showOTPForm, setShowOTPForm] = useState(false)
  const [showWarningAlert, setShowWarningAlert] = useState(false)
  const [showWarningAlert2, setShowWarningAlert2] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showCancelMessage, setShowCancelMessage] = useState(false)
  const [targetPaymentDateValue, setTargetPaymentDateValue] = useState(false)
  const [paymentDate, setPaymentDate] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [token, setToken] = useState('')
  const [bidderReferenceNumber, setBidderReferenceNumber] = useState('')
  const [BiddersAmountRequestedToBeRefund, setBiddersAmountRequestedToBeRefund] = useState('')
  const [BailiffAmountRequestedToBeRefunded, setBailiffAmountRequestedToBeRefunded] = useState('')
  const [NewBiddersAmountRequestedToBeRefunded, setNewBiddersAmountRequestedToBeRefunded] = useState('')
  const [NewBailiffAmountRequestedToBeRefunded, setNewBailiffAmountRequestedToBeRefunded] = useState('')
  const [ipAddress, setIpAddress] = useState<string>('')
  const [deviceName, setDeviceName] = useState<string>('')
  const [totalPaidForRange, setTotalPaidForRange] = useState('')

  const [generatedLink, setGeneratedLink] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [isRefundExist, setIsRefundExist] = useState(false)
  const [loadingCheck, setLoadingCheck] = useState(false)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleGenerateLink = () => {
    // eslint-disable-next-line max-len
    // const link = `http://10.8.126.222/bailiff-refund-request/bailiffBidSecurityReference/${bidderReferenceNumber}`
    // const link = `http://localhost:3000/bailiff-refund-request/bailiffBidSecurityReference/${bidderReferenceNumber}`
    const link = `https://payment.iecms.gov.rw/bailiff-refund-request/bailiffBidSecurityReference/${bidderReferenceNumber}`
    setGeneratedLink(link)
    alert(`Generated Link: ${link}`)
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleContinue = () => {
    if (declarationChecked) {
      setShowOTPForm(true)
    }
  }
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    async function fetchRefundStats () {
      setLoading(true)
      try {
        const response = await InstitutionUserService.viewRefundStatsByRefundStartDate(fromDate, toDate, token)
        const biddersAmountRequestedToBeRefund = response.data?.biddersAmountRequestedToBeRefund
        setBiddersAmountRequestedToBeRefund(response.data?.biddersAmountRequestedToBeRefund)
        const bailiffAmountRequestedToBeRefunded = response.data?.bailiffAmountRequestedToBeRefunded
        setBailiffAmountRequestedToBeRefunded(response.data?.bailiffAmountRequestedToBeRefunded)
        const newBiddersAmountRequestedToBeRefunded = response.data?.newBiddersAmountRequestedToBeRefunded
        setNewBiddersAmountRequestedToBeRefunded(response.data?.newBiddersAmountRequestedToBeRefunded)
        const newBailiffAmountRequestedToBeRefunded = response.data?.newBailiffAmountRequestedToBeRefunded
        setNewBailiffAmountRequestedToBeRefunded(response.data?.newBailiffAmountRequestedToBeRefunded)
        const tp = response.data?.totalPayments
        setTotalPaidForRange(tp != null && tp !== '' ? String(tp) : '')
      } catch (err) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        setError('Failed to fetch refund stats')
        // eslint-disable-next-line no-console
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    void fetchRefundStats()
  },
  [fromDate, toDate, token])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const checkRefundRequest = async () => {
      if (bidderReferenceNumber === '') return

      setLoadingCheck(true)
      try {
        const response = await InstitutionUserService.viewBailiffRefundRequestByReferenceNumber(bidderReferenceNumber)

        if (response?.status === 200 && Boolean(response.data)) {
          setIsRefundExist(true)
          setShowForm(false)
          const record = Array.isArray(response?.data) ? response.data[0] : response?.data
          const bailiffNameRaw = record?.beneficiary_account_name
          const bailiffName = (typeof bailiffNameRaw === 'string' && bailiffNameRaw.trim() !== '') ? bailiffNameRaw : 'the bailiff'
          const refText = (typeof bidderReferenceNumber === 'string' && bidderReferenceNumber.trim() !== '') ? bidderReferenceNumber : 'the provided reference number'
          const statusRaw = record?.status
          const statusText = (typeof statusRaw === 'string' && statusRaw.trim() !== '') ? statusRaw : 'Unknown'
          const amountRaw = record?.amount
          const currencyRaw = record?.transaction_currency
          const hasAmount = typeof amountRaw === 'number' || (typeof amountRaw === 'string' && amountRaw !== '')
          const amountText = hasAmount ? String(amountRaw).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null
          const currencyText = (typeof currencyRaw === 'string' && currencyRaw.trim() !== '') ? currencyRaw : 'RWF'
          const createdAtRaw = record?.created_at ?? record?.createdAt ?? record?.created_date
          const createdAtText = (createdAtRaw !== undefined && createdAtRaw !== null && createdAtRaw !== '')
            ? moment(createdAtRaw as string).format('YYYY-MM-DD HH:mm')
            : null
          const txnRef = (typeof record?.transaction_reference === 'string' && record?.transaction_reference.trim() !== '')
            ? record?.transaction_reference
            : refText

          Modal.confirm({
            title: 'Refund Request Exists',
            content: (
              <div>
                <p>
                  A refund request already exists for <strong>{txnRef}</strong> and was requested by <strong>{bailiffName}</strong>.
                </p>
                <p>
                  Status: <strong>{statusText}</strong>
                </p>
                {hasAmount && (
                  <p>
                    Requested Amount: <strong>{amountText} {currencyText}</strong>
                  </p>
                )}
                {(createdAtText !== null && createdAtText !== '') && (
                  <p>
                    Created At: <strong>{createdAtText}</strong>
                  </p>
                )}
              </div>
            ),
            okText: 'View details',
            cancelText: 'Close',
            onOk: () => {
              setIsRefundExist(false)
              navigate('/view-bailiff-refund-request', { state: record })
            },
            onCancel: () => { setIsRefundExist(false) }
          })
        } else {
          setShowForm(true)
          void message.success('No existing refund request found. You can proceed.')
        }
      } catch (error) {
        setShowForm(true)
        // void message.error('Error checking refund request. Please try again.')
        // eslint-disable-next-line no-console
        console.error('Error:', error)
      } finally {
        setLoadingCheck(false)
      }
    }
    void checkRefundRequest()
  }, [bidderReferenceNumber])

  const handleReferenceChange = async (value: string): Promise<void> => {
    setBidderReferenceNumber(value)
    if (value !== '') {
      setLoadingRefund(true)
      try {
        const paymentData = await InstitutionUserService.loadBidsDetailsForRefund(value)
        if (paymentData.status === 200) {
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-shadow
          const encryptReferenceNumber = (value: any) => {
            // Generate a random string to add
            const randomString = Math.random().toString(36).substring(2, 8) // Adjust length as needed
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const combinedValue = `${randomString}-${value}-${randomString}`
            const utf8Value = unescape(encodeURIComponent(combinedValue))
            return btoa(utf8Value)
          }
          const encryptedReference = encryptReferenceNumber(paymentData.data?.ref_number)
          // const generate_link = `http://10.8.126.222/refund-request/bidSecurityReference/${bidderReferenceNumber}`
          // const generate_link = `http://localhost:3000/bailiff-refund-request/bailiffRequestingBidSecurityFees/${encryptedReference}`
          const generate_link = `https://payment.iecms.gov.rw/bailiff-refund-request/bailiffRequestingBidSecurityFees/${encryptedReference}`
          form.setFieldsValue({
            bidder_id: paymentData.data?.bid?.bidder?.bidder_id,
            bid_security_id: paymentData.data?.payment?.bid_security_id,
            amount: paymentData.data?.payment?.amount,
            transaction_currency: paymentData.data?.payment?.currency,
            transaction_reference: paymentData.data?.ref_number,
            phone_number: paymentData.data?.bid?.bidder?.phone_number,
            bidder_national_id_number: paymentData.data?.bid?.bidder?.nid,
            property_id: paymentData.data?.bid?.auction?.property_id,
            execution_case_number: paymentData.data?.bid?.auction?.execution_case_no,
            fullname: paymentData.data?.bid?.bidder?.full_name,
            email: paymentData.data?.bid?.bidder?.email,
            payment_date: paymentData.data?.payment?.payment_date,
            generate_link
          })
          setPaymentDate(paymentData.data?.payment?.payment_date)
          setBiddersStatus(paymentData.status)
        } else {
          throw new Error('No data found for the given reference number.')
        }
      } catch (error: any) {
        Modal.error({
          title: 'Error',
          content: error
        })
      } finally {
        setLoadingRefund(false)
      }
    }
  }
  // Handle search button click
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSearchClick = () => {
    const referenceNumber = form.getFieldValue('bid_reference_number')

    // Validate input is not empty
    if (referenceNumber === null || referenceNumber === undefined || referenceNumber.trim() === '') {
      void message.warning('Please enter a bid reference number before searching')
      return
    }

    void handleReferenceChange(referenceNumber)
    setShowForm(true)
    setBidderReferenceNumber(form.getFieldValue('bid_reference_number'))
    // const link = `http://10.8.126.222/refund-request/bidSecurityReference/${bidderReferenceNumber}`
    // const link = `http://localhost:3000/bailiff-refund-request/bailiffBidSecurityReference/${bidderReferenceNumber}`
    const link = `https://payment.iecms.gov.rw/bailiff-refund-request/bailiffBidSecurityReference/${bidderReferenceNumber}`
    setGeneratedLink(link)
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const onFinish = async (values: any): void => {
    const paymentDateTime = moment(paymentDate, 'YYYY-MM-DD HH:mm:ss')
    const targetPaymentDate = moment('2022-07-25', 'YYYY-MM-DD')
    // Check if payment date is valid for a refund
    if (!paymentDateTime.isSameOrAfter(targetPaymentDate)) {
      setLoadingRefund(false)
      setShowWarningAlert2(true)
      // Optionally show a warning message
      return
    }
    // Construct the payload for the refund request
    const payload = {
      RefundRequest: {
        transaction_reference: values.transaction_reference,
        debit_account_number: '000400696575429',
        debit_account_name: 'MINIJUST AUCTION FUNDS MAF',
        transaction_currency: values.transaction_currency,
        reason: 'Did not requesting bid security under his/her account due to missing data',
        status: 'PENDING',
        bidder_id: form.getFieldValue('bidder_id'),
        bid_security_id: form.getFieldValue('bid_security_id'),
        phone_number: values.phone_number,
        bailiff_email: form.getFieldValue('bailiff_email'),
        link: form.getFieldValue('generate_link'),
        created_by: userInfo.full_name
      }
    }
    setLoadingRefund(true)
    try {
      const body = {
        transaction_reference: bidderReferenceNumber
      }
      let refundAlreadyExists = false

      try {
        const validateRequest = await InstitutionUserService.validateBailiffRefundRequest(body)
        if (validateRequest !== null && validateRequest.status === 200) {
          refundAlreadyExists = true
        }
      } catch (validationError: any) {
        const validationStatus = validationError?.response?.status
        if (validationStatus !== 404) {
          throw validationError
        }
      }

      if (refundAlreadyExists) {
        const fallbackTransactionReference = String(values.transaction_reference ?? '').trim()
        Modal.warning({
          title: 'Request Not Processed',
          content: `Refund Request already exists with: Transaction Reference Number ${fallbackTransactionReference}`
        })
        return
      }

      const res = await InstitutionUserService.SendBailiffRefundRequestLink(payload, token)
      if (res.status === 201 || res.status === 200) {
        const associatedBidderEmail = String(form.getFieldValue('bailiff_email') ?? values.bailiff_email ?? '').trim()
        Modal.success({
          title: 'Success',
          content: `Link has been submitted to ${associatedBidderEmail !== '' ? associatedBidderEmail : 'associated bidder email'}`
        })
        const generatedUuid = uuidv4()
        const param = { transaction_reference: values.transaction_reference }
        const getLastRefundReferenceNumber = await InstitutionUserService.getBailiffRefundRequestId(param)

        const refundRequestId = getLastRefundReferenceNumber?.data?.refund_request_id

        if (refundRequestId !== null) {
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          // void message.info(`Refund Request ID: ${refundRequestId}`)
        } else {
          void message.error('Unable to retrieve Refund Request ID')
        }
        const AuditPayload = {
          AuditLogsData: {
            action: 'INSERT',
            table_name: 'refund_request',
            record_id: generatedUuid,
            old_data: payload,
            new_data: {},
            created_by: userInfo.full_name,
            refund_request_id: refundRequestId
          }
        }
        await InstitutionUserService.TrackRecords(AuditPayload)
      } else {
        void message.error('Failed to submit the refund request. Please try again.')
      }
    } catch (error: any) {
      const errorMessage = String(error?.response?.data?.message ?? error?.message ?? 'Failed to submit the refund request. Please try again.')
      Modal.warning({
        title: 'Request Not Processed',
        content: errorMessage
      })
    } finally {
      setLoadingRefund(false)
    }
  }

  return (
    <div className="w-full">
      {/* Add custom styles */}
      <style>{`
        .enhanced-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-input {
          border-radius: 8px;
          border: 2px solid #e5e7eb;
          transition: border-color 0.2s ease;
        }
        .enhanced-input:focus {
          border-color: #37762f;
          box-shadow: 0 0 0 3px rgba(55, 118, 47, 0.1);
        }
        .enhanced-button {
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.2s ease;
        }
        .enhanced-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      `}</style>

      {/* Enhanced page header */}
      <div className="px-5 py-4 border-b-slate-200 border border-solid w-full" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px'
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-bold flex items-center">
            <div style={{
              background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)'
            }}>
              <span style={{ fontSize: '24px' }}>⚖️</span>
            </div>
            <div>
              <h2 className="text-title font-bold" style={{
                margin: 0,
                background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Claim Refund Requests
              </h2>
              <p style={{
                margin: '4px 0 0 0',
                fontSize: '14px',
                color: '#6b7280',
                fontWeight: '500'
              }}>
                🔗 Generate Bailiff Refund Request Links • Legal Process Management
              </p>
            </div>
          </div>
          <div className="md:w-1/5"></div>
        </div>
      </div>

      {/* Enhanced Responsive Links Section */}
      <div className="flex flex-col md:flex-row gap-3 items-start justify-start w-full mb-6 mt-2">
        {/* Enhanced Update for Public Treasury Link */}
        {userRole === 'MINIJUST FINANCE' && (
          <>
            <span style={{
              color: '#9ca3af',
              fontSize: '16px',
              margin: '0 8px',
              display: 'none'
            }} className="md:inline">||</span>
            <a
              href="/update-for-public-treasury"
              style={{
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                color: 'white',
                textDecoration: 'none',
                padding: '12px 24px',
                borderRadius: '12px',
                fontWeight: '600',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '220px',
                boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                transition: 'all 0.2s ease',
                marginBottom: '8px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(245, 158, 11, 0.4)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.3)'
              }}
            >
              <span style={{ fontSize: '16px' }}>🏛️</span>
              Update for Public Treasury
            </a>
          </>
        )}
      </div>

      <div>
        {loadingCheck && <p>Loading...</p>}
        {isRefundExist && <p>Refund exists for this reference number.</p>}
      </div>

      <RefundStatsRangeAlert fromDate={fromDate} toDate={toDate} />
      {/* Enhanced stats section with hover effects */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        gap: '20px',
        padding: '20px',
        backgroundColor: '#fafafa',
        borderRadius: '8px',
        margin: '0 20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div
          style={{
            flex: '1',
            minWidth: 180,
            background: '#F5F5F5',
            padding: '20px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            textAlign: 'center',
            color: '#1e293b',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            cursor: 'default'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
        >
          <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>
            Total Amount Requested
          </div>
          <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {((parseMoneyAmount(BailiffAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(BiddersAmountRequestedToBeRefund) ?? 0)).toLocaleString()} Rwf
          </div>
        </div>

        <div
          style={{
            flex: '1',
            minWidth: 180,
            background: '#F5F5F5',
            padding: '20px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            textAlign: 'center',
            color: '#1e293b',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            cursor: 'default'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
        >
          <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>
            New Amount Requested
          </div>
          <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded) ?? 0)).toLocaleString()} Rwf
          </div>
        </div>

        <div
          style={{
            flex: '1',
            minWidth: 180,
            background: '#F5F5F5',
            padding: '20px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            textAlign: 'center',
            color: '#1e293b',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            cursor: 'default'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
        >
          <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>
            Remaining to Request
          </div>
          <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {Math.max(
              0,
              parseMoneyAmount(totalPaidForRange) - (parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))
            ).toLocaleString()} Rwf
          </div>
        </div>

        <div
          style={{
            flex: '1',
            minWidth: 180,
            background: '#F5F5F5',
            padding: '20px',
            borderRadius: '12px',
            border: 'none',
            textAlign: 'center',
            color: '#2c5530',
            boxShadow: '0 4px 15px rgba(168, 237, 234, 0.3)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            cursor: 'default'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(168, 237, 234, 0.4)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(168, 237, 234, 0.3)'
          }}
        >
          <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>
            Total Paid Amount
          </div>
          <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
            {(parseMoneyAmount(totalPaidForRange)).toLocaleString()} Rwf
          </div>
        </div>

        <div
          style={{
            flex: '1',
            minWidth: 180,
            background: '#F5F5F5',
            padding: '20px',
            borderRadius: '12px',
            border: 'none',
            textAlign: 'center',
            color: '#2c5530',
            boxShadow: '0 4px 15px rgba(168, 237, 234, 0.3)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            cursor: 'default'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
        >
          <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>
            Total Refunded Amount
          </div>
          <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {(((parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))) - ((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded)) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded)))).toLocaleString()} Rwf
          </div>
        </div>
      </div>

      {/* Enhanced division title */}
      <div style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        padding: '20px',
        borderRadius: '12px',
        margin: '20px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
      }}>
        <Row justify="start" gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <h2 style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              margin: 0,
              lineHeight: '1.5'
            }}>
              📝 Provide the bid security reference number so the link can be sent to bailiffs,
              allowing them to request 5% of the bid security paid.
            </h2>
          </Col>
        </Row>
      </div>

      <div className="request-ref p-2 sm:p-4 lg:p-8" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '12px',
        margin: '20px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
      }}>
        <Form
          name="normal_login"
          layout="vertical"
          className="login-form"
          autoComplete="off"
          form={form}
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Card
            className="max-w-full md:max-w-2xl xl:max-w-3xl 2xl:max-w-5xl mx-auto p-2 md:p-4 xl:p-8 2xl:p-12"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid #e5e7eb'
            }}
          >
            <div className="flex flex-col gap-y-2 md:gap-y-4">
              {/* Enhanced form section */}
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Form.Item
                    label={
                      <span style={{
                        fontWeight: '500',
                        color: '#374151',
                        fontSize: '14px'
                      }}>
                        🔗 Bid Reference Number
                      </span>
                    }
                    name="bid_reference_number"
                    rules={[
                      {
                        required: true,
                        message: 'Please input the bid reference number!'
                      }
                    ]}
                    style={{ width: '100%' }}
                  >
                    <Input
                      placeholder="Enter Bid Reference Number"
                      className="enhanced-input"
                      style={{
                        borderRadius: '8px',
                        width: '100%',
                        height: '48px',
                        fontSize: '16px',
                        border: '2px solid #e5e7eb',
                        transition: 'border-color 0.2s ease'
                      }}
                      onChange={(e) => { setBidderReferenceNumber(e.target.value) }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}></Col>
                <Col xs={24} sm={12} md={8} lg={6}></Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Button
                    type="primary"
                    onClick={handleSearchClick}
                    loading={loadingRefund}
                    disabled={isRefundExist}
                    block
                    className="enhanced-button"
                    style={{
                      background: isRefundExist
                        ? '#d1d5db'
                        : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      border: 'none',
                      borderRadius: '8px',
                      height: '48px',
                      fontSize: '16px',
                      fontWeight: '600',
                      boxShadow: isRefundExist
                        ? 'none'
                        : '0 4px 12px rgba(16, 185, 129, 0.3)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      if (!isRefundExist) {
                        e.currentTarget.style.transform = 'translateY(-1px)'
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)'
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isRefundExist) {
                        e.currentTarget.style.transform = 'translateY(0)'
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)'
                      }
                    }}
                  >
                    🔍 Search
                  </Button>
                </Col>
              </Row>

              <div className="spacing-row mt-4">
                {showForm && biddersStatus && (
                  <p className="text-gray-600">
                    View Bidders Details and Generate Link for Bidder to request 5% of bid Security.
                  </p>
                )}
              </div>

              {showForm && biddersStatus && (
                <div style={{ width: '100%' }}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Phone Number"
                        name="phone_number"
                        rules={[
                          { required: true, message: 'Please enter Phone Number' },
                          { pattern: PHONE_PATTERN, message: 'Phone number should be 10 digits.' }
                        ]}
                      >
                        <Input
                          type="tel"
                          placeholder="Enter Phone Number"
                          disabled
                          prefix={<i className="fas fa-phone-alt text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="National ID"
                        name="bidder_national_id_number"
                        rules={[
                          { required: true, message: 'Please enter Your National ID' },
                          { message: 'National ID should be 16 digits.' }
                        ]}
                      >
                        <Input
                          placeholder="National ID is missing"
                          maxLength={16}
                          disabled
                          prefix={<i className="fas fa-address-card text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Property ID"
                        name="property_id"
                        rules={[{ required: true, message: 'Please enter Property ID' }]}
                      >
                        <Input
                          placeholder="Enter Property ID"
                          disabled
                          prefix={<i className="fas fa-home text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Execution Case Number"
                        name="execution_case_number"
                        rules={[{ required: true, message: 'Please enter Execution Case Number' }]}
                      >
                        <Input
                          placeholder="Execution Case Number"
                          disabled
                          prefix={<i className="fas fa-gavel text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Transaction Reference"
                        name="transaction_reference"
                        rules={[{ required: true, message: 'Please enter transaction reference' }]}
                      >
                        <Input
                          placeholder="Transaction Reference"
                          disabled
                          prefix={<i className="fas fa-cogs text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Bidder's Names"
                        name="fullname"
                        rules={[{ required: true, message: 'Please enter Bidders Name' }]}
                      >
                        <Input
                          placeholder="Bidders Name"
                          disabled
                          prefix={<i className="fas fa-user text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Deposit Bid Security Amount"
                        name="amount"
                        rules={[{ required: true, message: 'Please enter Amount' }]}
                      >
                        <Input
                          type="text"
                          placeholder="Amount"
                          disabled
                          prefix={<i className="fas fa-dollar-sign text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Currency"
                        name="transaction_currency"
                        rules={[{ required: true, message: 'Please provide the transaction currency' }]}
                      >
                        <Input
                          maxLength={24}
                          placeholder="RWF"
                          disabled
                          prefix={<i className="fas fa-money-bill-alt text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Bid Security Payment Date"
                        name="payment_date"
                        rules={[{ required: true, message: 'Payment Date not Available' }]}
                      >
                        <Input
                          placeholder="Bid Payment Date"
                          disabled
                          prefix={<i className="fas fa-calendar-alt text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={24} lg={24}>
                      <Form.Item
                        label="Enter email for bailiff requesting 5% of bid security"
                        name="bailiff_email"
                        rules={[{ required: true, message: 'Bailiff Email is missing' }]}
                      >
                        <Input
                          placeholder="Bailiff Email"
                          prefix={<i className="fas fa-calendar-alt text-gray-400" />}
                          style={{ borderRadius: '8px' }}
                        />
                      </Form.Item>
                    </Col>

                  </Row>

                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} md={8} lg={6}>
                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={loadingRefund}
                          onClick={handleContinue}
                          block
                          className="enhanced-button"
                          style={{
                            background: loadingRefund
                              ? '#d1d5db'
                              : 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            height: '48px',
                            fontSize: '16px',
                            fontWeight: '600',
                            boxShadow: loadingRefund
                              ? 'none'
                              : '0 4px 12px rgba(55, 118, 47, 0.3)',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            if (!loadingRefund) {
                              e.currentTarget.style.transform = 'translateY(-1px)'
                              e.currentTarget.style.boxShadow = '0 6px 16px rgba(55, 118, 47, 0.4)'
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!loadingRefund) {
                              e.currentTarget.style.transform = 'translateY(0)'
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(55, 118, 47, 0.3)'
                            }
                          }}
                        >
                          ✅ {isEdit ? 'Update' : 'Submit'}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}

            </div>
          </Card>

        </Form>
        {loadingCheck && <Spin />}
        {isRefundExist && <Alert message="Refund request already exists." type="info" />}
      </div>

      <Row justify="center" align="middle" style={{ height: '100%' }}>
        <Col xs={24} md={24} xl={24}>
          {showSuccessAlert && (
            <Modal
              visible={showSuccessAlert}
              onCancel={() => {
                setShowSuccessAlert(false)
              }}
              footer={null}
              centered
            >
              <Alert
                message="Informational Notes"
                /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                description="Refund Request Submitted. Waiting to be Refunded..."
                type="info"
                showIcon
                style={{
                  width: '100%'
                }} // Set alert background color
                onClose={() => {
                  setShowSuccessAlert(false)
                }}
              />
            </Modal>
          )}
        </Col>
      </Row>
      <Row justify="center" align="middle" style={{ height: '100%' }}>
        <Col xs={24} md={24} xl={24}>
          {showWarningAlert && (
            <Modal
              visible={showWarningAlert}
              onCancel={() => {
                setShowWarningAlert(false)
              }}
              footer={null}
              centered
            >
              <Alert
                message="Informational Notes"
                /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                description={
                  'Refund Request already exists with the same Transaction Reference Number:'
                }
                type="info"
                showIcon
                style={{
                  width: '100%'
                }} // Set alert background color
                onClose={() => {
                  setShowWarningAlert(false)
                }}
              />
            </Modal>
          )}
        </Col>
      </Row>
      <Row justify="center" align="middle" style={{ height: '100%' }}>
        <Col xs={24} md={24} xl={24}>
          {showWarningAlert2 && (
            <Modal
              visible={showWarningAlert2}
              onCancel={() => {
                setShowWarningAlert2(false)
              }}
              footer={null}
              centered
            >
              <Alert
                message="Informational Notes"
                /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                description={`Refund can only be triggered for payments starting from ${targetPaymentDateValue}. Any assistance, please contact us at iecms-support@minijust.gov.rw`}
                type="error"
                showIcon
                style={{
                  width: '100%'
                }} // Set alert background color
                onClose={() => {
                  setShowWarningAlert2(false)
                }}
              />
            </Modal>
          )}
        </Col>
      </Row>
      {showCancelMessage && (
        <div className="cancel-message">
          <div className="separator"></div>
          <p>
            <h3>Thank you for using our services.</h3>
          </p>
          <div className="separator"></div>
          <p>
            For any other support, please contact us on
            <span>
              <strong> iecms-support@minijust.gov.rw</strong>
            </span>
            .
          </p>
        </div>
      )}
    </div>
  )
}

export default RequestPaymentClaim
